//#region src/chains.ts
/** Safe Devnet */
const SAFE_DEVNET_CHAIN = "safe:devnet";
/** Safe Testnet */
const SAFE_TESTNET_CHAIN = "safe:testnet";
/** Safe Localnet */
const SAFE_LOCALNET_CHAIN = "safe:localnet";
/** Safe Mainnet */
const SAFE_MAINNET_CHAIN = "safe:mainnet";
const SAFE_CHAINS = [
	SAFE_DEVNET_CHAIN,
	SAFE_TESTNET_CHAIN,
	SAFE_LOCALNET_CHAIN,
	SAFE_MAINNET_CHAIN
];
/**
* Utility that returns whether or not a chain identifier is a valid Safe chain.
* @param chain a chain identifier in the form of `${string}:{$string}`
*/
function isSafeChain(chain) {
	return SAFE_CHAINS.includes(chain);
}
//#endregion
export { SAFE_CHAINS, SAFE_DEVNET_CHAIN, SAFE_LOCALNET_CHAIN, SAFE_MAINNET_CHAIN, SAFE_TESTNET_CHAIN, isSafeChain };

//# sourceMappingURL=chains.mjs.map